import { type GroupChannelListProps } from '@sendbird/uikit-react/GroupChannelList';
import GroupChannelListHeader from '@sendbird/uikit-react/GroupChannelList/components/GroupChannelListHeader';
import { CreateChannelProvider } from '@sendbird/uikit-react/CreateChannel/context';
import { GroupChannelListProvider } from '@sendbird/uikit-react/GroupChannelList/context';
import { GroupCustomChannelListUI } from './GroupCustomChannelListUI';
import { useSearchControl } from './SearchControlContext';
import { useDebounce } from '../../../hooks/useDebounce';
import { GroupChannelListHeaderMiddle } from './GroupChannelListHeaderMiddle';

export const GroupCustomChannelList = (props: GroupChannelListProps) => {
  const { searchMode, searchTerm } = useSearchControl();
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  const channelListQueryParams = {
    limit: 100,
    // Only one filter can be applied at a time
    ...(searchMode === 'employee'
      ? { nicknameStartsWithFilter: debouncedSearchTerm }
      : { channelNameContainsFilter: debouncedSearchTerm }),
    includeEmpty: true,
  };

  return (
    <CreateChannelProvider onChannelCreated={props.onChannelCreated}>
      <GroupChannelListProvider
        {...props}
        channelListQueryParams={channelListQueryParams}
      >
        <GroupCustomChannelListUI
          renderHeader={() => (
            <GroupChannelListHeader
              renderMiddle={() => <GroupChannelListHeaderMiddle />}
            />
          )}
        />
      </GroupChannelListProvider>
    </CreateChannelProvider>
  );
};
